import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroBanner } from '../components/HeroBanner';
import { DivisionCard } from '../components/DivisionCard';
import { GameCard } from '../components/GameCard';
import { SongCard } from '../components/SongCard';
import { FilmCard } from '../components/FilmCard';
import { DevCard } from '../components/DevCard';

import { divisions } from '../data/divisions';
import { gameProjects } from '../data/games';
import { highlightSongs } from '../data/songs';
import { filmProjects } from '../data/films';
import { devPosts } from '../data/devPosts';

export function renderHome(): string {
  const divisionCardsHtml = divisions.map(div => DivisionCard(div)).join('');
  const featuredGamesHtml = gameProjects.slice(0, 3).map(game => GameCard(game)).join('');
  const featuredSongsHtml = highlightSongs.slice(0, 3).map(song => SongCard(song)).join('');
  const featuredFilmsHtml = filmProjects.slice(0, 2).map(film => FilmCard(film)).join('');
  const featuredDevsHtml = devPosts.slice(0, 2).map(post => DevCard(post)).join('');

  return /*html*/`
    ${Header()}
    
    <main class="fade-in">
      <!-- Flagship Hero Section -->
      ${HeroBanner()}

      <!-- Studio Divisions Overview -->
      <section class="container" style="padding: 5rem 1.5rem 3rem;">
        <div class="section-header">
          <div class="badge badge-cyan" style="margin-bottom: 0.75rem;">Core Works &amp; Interests</div>
          <h2>Explore the <span class="text-gradient">AtomixM Universe</span></h2>
          <p>
            From low-level game engines to generative neural music, cinematic AI films, and vibe-coding architecture.
          </p>
        </div>
        <div class="grid grid-2" style="gap: 2rem;">
          ${divisionCardsHtml}
        </div>
      </section>

      <!-- Featured Games Section -->
      <section style="background: rgba(6, 214, 160, 0.03); border-top: 1px solid rgba(6, 214, 160, 0.1); border-bottom: 1px solid rgba(6, 214, 160, 0.1); padding: 5rem 0;">
        <div class="container">
          <div style="display: flex; justify-content: space-between; align-items: flex-end; flex-wrap: wrap; gap: 1rem; margin-bottom: 2.5rem;">
            <div>
              <span class="badge badge-green" style="margin-bottom: 0.5rem;">AtomixGame</span>
              <h2 style="font-size: 2.2rem;">Open-Source Engines &amp; Games</h2>
            </div>
            <a href="#games" class="btn-ghost" style="border-color: rgba(6, 214, 160, 0.3); color: #34d399;">
              <span>View All Engines &amp; Games →</span>
            </a>
          </div>
          <div class="grid grid-3">
            ${featuredGamesHtml}
          </div>
        </div>
      </section>

      <!-- Featured Music Section -->
      <section style="padding: 5rem 0;">
        <div class="container">
          <div style="display: flex; justify-content: space-between; align-items: flex-end; flex-wrap: wrap; gap: 1rem; margin-bottom: 2.5rem;">
            <div>
              <span class="badge badge-purple" style="margin-bottom: 0.5rem;">AtomixMusics</span>
              <h2 style="font-size: 2.2rem;">Featured AI Compositions</h2>
            </div>
            <a href="#musics" class="btn-ghost" style="border-color: rgba(168, 85, 247, 0.3); color: #c084fc;">
              <span>Browse All AI Tracks →</span>
            </a>
          </div>
          <div class="grid grid-3">
            ${featuredSongsHtml}
          </div>
        </div>
      </section>

      <!-- Featured Films & Shorts Section -->
      <section style="background: rgba(249, 115, 22, 0.03); border-top: 1px solid rgba(249, 115, 22, 0.1); border-bottom: 1px solid rgba(249, 115, 22, 0.1); padding: 5rem 0;">
        <div class="container">
          <div style="display: flex; justify-content: space-between; align-items: flex-end; flex-wrap: wrap; gap: 1rem; margin-bottom: 2.5rem;">
            <div>
              <span class="badge badge-orange" style="margin-bottom: 0.5rem;">AtomixFilms</span>
              <h2 style="font-size: 2.2rem;">AI Cinema &amp; Drama Shorts</h2>
            </div>
            <a href="#films" class="btn-ghost" style="border-color: rgba(249, 115, 22, 0.3); color: #fb923c;">
              <span>View All Films &amp; Series →</span>
            </a>
          </div>
          <div class="grid grid-2">
            ${featuredFilmsHtml}
          </div>
        </div>
      </section>

      <!-- Featured Dev Blog & Vibe Coding Section -->
      <section style="padding: 5rem 0;">
        <div class="container">
          <div style="display: flex; justify-content: space-between; align-items: flex-end; flex-wrap: wrap; gap: 1rem; margin-bottom: 2.5rem;">
            <div>
              <span class="badge badge-cyan" style="margin-bottom: 0.5rem;">AtomixDevs</span>
              <h2 style="font-size: 2.2rem;">Vibe Coding &amp; Architecture Articles</h2>
            </div>
            <a href="https://atomixnmc.github.io/mydevblog/" target="_blank" rel="noopener noreferrer" class="btn-ghost" style="border-color: rgba(0, 242, 254, 0.3); color: #38bdf8;">
              <span>Visit mydevblog Live →</span>
            </a>
          </div>
          <div class="grid grid-2">
            ${featuredDevsHtml}
          </div>
        </div>
      </section>

    </main>
    
    ${Footer()}
  `;
}
